// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const FolderRoot = (): React.Element<*> => (
  <path d="M16.498 3.99h-6.55c-0.232-1.14-1.242-2-2.45-2h-4c-1.378 0-2.5 1.122-2.5 2.5v11c0 1.378 1.122 2.5 2.5 2.5h13c1.379 0 2.5-1.122 2.5-2.5v-9c0-1.378-1.121-2.5-2.5-2.5zM17.998 7.491c-0.411-0.313-0.932-0.501-1.497-0.501-0.001 0-0.002 0-0.003 0h-13c-0.001 0-0.002 0-0.003 0-0.565 0-1.086 0.188-1.504 0.506l0.006-0.004v-3.001c0.003-0.827 0.673-1.497 1.5-1.5h4c0.827 0.003 1.497 0.673 1.5 1.5v0c0 0.276 0.224 0.5 0.5 0.5v0h7c0.827 0.003 1.497 0.673 1.5 1.5v0z"></path>
);
